export default "__VITE_ASSET__$n5ta6AE__"